import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveTypedFormsModule } from '@rxweb/reactive-form-validators';

@Component({
    selector: 'mobilize-requests-search',
    imports: [
        ReactiveTypedFormsModule
    ],
    templateUrl: './requests-search.component.html',
    styleUrl: './requests-search.component.scss'
})
export class RequestsSearchComponent {

    @Input() query = '';
    @Input() placeholder = '';
    @Output() onSearch = new EventEmitter<any>();

    search() {
        this.onSearch.emit(this.query);
    }
}
